// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.quill {
    margin: 1rem;
  }
  
   .ql-container {
    background: #fefcfc;
    margin-bottom: 1%;
  
  }

  .quill .ql-snow.ql-toolbar {
    display: block;
  }
  .quill > .ql-container > .ql-editor.ql-blank::before{
    font-family: sans-serif;
    font-style: normal;
}

  .quill .ql-editor {
    min-height: 4em;
    font-size: 1rem;
    font-style: normal;
  }
  .quill .ql-formats button {
    position: relative
  }

  .quill .ql-formats button:hover:after,
  .quill .ql-formats button:active:after,
  .quill .ql-formats button:focus:after {
      position: absolute;
      background: black;
      color: white;
      padding: .2em;
      border-radius: .5em;
      left: -50%;
      top: 100%;
      width: max-content;
      z-index: 1;
      font-size: 0.7rem;
  }

  .quill .ql-bold:hover:after,
  .quill .ql-bold:active:after,
  .quill .ql-bold:focus:after {
     content: 'Bold Ctrl B';
  }
  .quill .ql-italic:hover:after,
  .quill .ql-italic:active:after,
  .quill .ql-italic:focus:after {
     content: 'Italic Ctrl I';
  }
  .quill .ql-underline:hover:after,
  .quill .ql-underline:active:after,
  .quill .ql-underline:focus:after {
     content: 'Underline Ctrl U';
  }
  .quill .ql-strike:hover:after,
  .quill .ql-strike:active:after,
  .quill .ql-strike:focus:after {
     content: 'StrikeThrough';
  }
  .quill .ql-size:hover:after,
  .quill .ql-size:active:after,
  .quill .ql-size:focus:after {
     content: 'Size';
  }
  .quill .ql-script[value="sub"]:hover:after,
  .quill .ql-script:active:after,
  .quill .ql-script:focus:after {
     content: 'SubScript';
  }
  .quill .ql-script[value="super"]:hover:after,
  .quill .ql-script:active:after,
  .quill .ql-script:focus:after {
     content: 'SuperScript';
  }
  .quill .ql-color:hover:after,
  .quill .ql-color:active:after,
  .quill .ql-color:focus:after {
     content: 'Color';
  }
  `, "",{"version":3,"sources":["webpack://./src/ui/pages/container/Label-Studio/editor.css"],"names":[],"mappings":";AACA;IACI,YAAY;EACd;;GAEC;IACC,mBAAmB;IACnB,iBAAiB;;EAEnB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,kBAAkB;AACtB;;EAEE;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE;EACF;;EAEA;;;MAGI,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,UAAU;MACV,SAAS;MACT,kBAAkB;MAClB,UAAU;MACV,iBAAiB;EACrB;;EAEA;;;KAGG,sBAAsB;EACzB;EACA;;;KAGG,wBAAwB;EAC3B;EACA;;;KAGG,2BAA2B;EAC9B;EACA;;;KAGG,wBAAwB;EAC3B;EACA;;;KAGG,eAAe;EAClB;EACA;;;KAGG,oBAAoB;EACvB;EACA;;;KAGG,sBAAsB;EACzB;EACA;;;KAGG,gBAAgB;EACnB","sourcesContent":["\n.quill {\n    margin: 1rem;\n  }\n  \n   .ql-container {\n    background: #fefcfc;\n    margin-bottom: 1%;\n  \n  }\n\n  .quill .ql-snow.ql-toolbar {\n    display: block;\n  }\n  .quill > .ql-container > .ql-editor.ql-blank::before{\n    font-family: sans-serif;\n    font-style: normal;\n}\n\n  .quill .ql-editor {\n    min-height: 4em;\n    font-size: 1rem;\n    font-style: normal;\n  }\n  .quill .ql-formats button {\n    position: relative\n  }\n\n  .quill .ql-formats button:hover:after,\n  .quill .ql-formats button:active:after,\n  .quill .ql-formats button:focus:after {\n      position: absolute;\n      background: black;\n      color: white;\n      padding: .2em;\n      border-radius: .5em;\n      left: -50%;\n      top: 100%;\n      width: max-content;\n      z-index: 1;\n      font-size: 0.7rem;\n  }\n\n  .quill .ql-bold:hover:after,\n  .quill .ql-bold:active:after,\n  .quill .ql-bold:focus:after {\n     content: 'Bold Ctrl B';\n  }\n  .quill .ql-italic:hover:after,\n  .quill .ql-italic:active:after,\n  .quill .ql-italic:focus:after {\n     content: 'Italic Ctrl I';\n  }\n  .quill .ql-underline:hover:after,\n  .quill .ql-underline:active:after,\n  .quill .ql-underline:focus:after {\n     content: 'Underline Ctrl U';\n  }\n  .quill .ql-strike:hover:after,\n  .quill .ql-strike:active:after,\n  .quill .ql-strike:focus:after {\n     content: 'StrikeThrough';\n  }\n  .quill .ql-size:hover:after,\n  .quill .ql-size:active:after,\n  .quill .ql-size:focus:after {\n     content: 'Size';\n  }\n  .quill .ql-script[value=\"sub\"]:hover:after,\n  .quill .ql-script:active:after,\n  .quill .ql-script:focus:after {\n     content: 'SubScript';\n  }\n  .quill .ql-script[value=\"super\"]:hover:after,\n  .quill .ql-script:active:after,\n  .quill .ql-script:focus:after {\n     content: 'SuperScript';\n  }\n  .quill .ql-color:hover:after,\n  .quill .ql-color:active:after,\n  .quill .ql-color:focus:after {\n     content: 'Color';\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
